import { useEffect, useState } from "react";
import V2DashboardService from "../../services/v2/all/admin/DashboardService/dashboard.service";

export const useAllStudentActivities = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [totalAllCount, setTotalAllCount] = useState(0);
  const [loginCount, setLoginCount] = useState(0);
  const [notLoginCount, setNotLoginCount] = useState(0);

  useEffect(() => {
    V2DashboardService.getTotalAllStudentsCount(
      {},
      (data) => {
        setTotalAllCount(data);
        setIsLoading(false);
      },
      () => {},
      () => {}
    );

    V2DashboardService.getLoginCount(
      {},
      (data) => {
        setLoginCount(data);
        setIsLoading(false);
      },
      () => {},
      () => {}
    );

    V2DashboardService.getNotLoggedInCount(
      {},
      (data) => {
        setNotLoginCount(data);
        setIsLoading(false);
      },
      () => {},
      () => {}
    );
  }, []);

  return { totalAllCount, loginCount, notLoginCount, isLoading };
};
